import { Loading } from "quasar";

function useLoading(message: string) {

  Loading.show({
    message: `<div class="tw-text-md" style="min-width: 150px">${message}</div>`,
    html: true,
    boxClass: 'bg-grey-2 text-grey-9',
    spinnerColor: 'primary'
  })
}


function useHideLoading() {
  Loading.hide();
}

export {
  useLoading,
  useHideLoading
}
